<ngx-spinner bdColor="rgba(0,0,0,0.28)" size="small" color="#fff" type="ball-pulse" 
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>
<button *ngIf="isShow" (click)="gotoTop()">
  <i class="fa fa-chevron-up" aria-hidden="true"></i>
</button>